import { CLAConfig } from '../types/ConfigTypes';

export const getLendingConfig = (): CLAConfig | undefined => {
  const globalConfig = window.ConfigUtility;

  if (!globalConfig) {
    console.warn('Unable to load lending config.');
    return;
  }

  return {
    agGridLicenseKey: globalConfig.agGridLicenseKey,
    apiBaseUri: globalConfig.apiBaseUri,
    apiUrl: globalConfig.claApiUrl,
    app: globalConfig.app,
    b4olaunchDarklyClientId: globalConfig.b4olaunchDarklyClientId,
    claLaunchDarklyClientId: globalConfig.claLaunchDarklyClientId,
    clientId: globalConfig.claClientId,
    consoleURL: globalConfig.consoleURL,
    dashboardDomain: globalConfig.dashboardDomain,
    dev: globalConfig.dev,
    env: globalConfig.claenv,
    errorLog: globalConfig.claErrorLog,
    errorNotify: globalConfig.claErrorNotify,
    fakeJwtToken: globalConfig.fakeJwtToken,
    fullstoryEnabled: globalConfig.fullstoryEnabled,
    fullstoryOrgId: globalConfig.fullstoryOrgId,
    googleAnalyticsLog: globalConfig.claGoogleAnalyticsLog,
    googleApiKey: globalConfig.claGoogleApiKey,
    googleMapsEnabled: globalConfig.claGoogleMapsEnabled,
    launchDarklyClientId: globalConfig.lendingGenericLaunchDarklyClientId,
    launchDarklyProxyURL: globalConfig.launchDarklyProxyURL,
    loadFixtures: globalConfig.loadFixtures,
    lendingURL: globalConfig.lendingURL,
    loginURL: globalConfig.loginURL,
    logoutURL: globalConfig.logoutURL,
    mapBoxAccessToken: globalConfig.mapBoxAccessToken,
    monitoring: {
      applicationId: globalConfig.monitoring?.applicationId,
      clientToken: globalConfig.monitoring?.clientToken,
    },
    newRelicAppName: globalConfig.claNewRelicAppName,
    newRelicEnabled: globalConfig.claNewRelicEnabled,
    newRelicLicenseKey: globalConfig.claNewRelicLicenseKey,
    pendoApiKey: globalConfig.claPendoApiKey,
    pendoEnabled: globalConfig.claPendoEnabled,
    platformLaunchDarklyClientId: globalConfig.platformLaunchDarklyClientId,
    restUrl: globalConfig.claRestUrl,
    runMode: globalConfig.claRunMode,
    salesforceApiEndpoint: globalConfig.claSalesforceApiEndpoint,
    salesforceDeploymentId: globalConfig.claSalesforceDeploymentId,
    salesforceOrganizationId: globalConfig.claSalesforceOrganizationId,
    sentryEnabled: globalConfig.claSentryEnabled,
    sentryURL: globalConfig.claSentryURL,
    snowplowURL: globalConfig.snowplowURL,
    standalone: globalConfig.claStandalone,
    tokenLife: globalConfig.tokenLife,
    useDevTools: globalConfig.useDevTools,
    userPoolId: globalConfig.cognito.userPoolId,
    useSecure: globalConfig.useSecure,
    cognito: {
      isEnabled: globalConfig.cognito.isEnabled,
      isMocked: globalConfig.cognito.isMocked,
      region: globalConfig.cognito.region,
      userPoolId: globalConfig.cognito.userPoolId,
      userPoolWebClientId: globalConfig.cognito.claUserPoolWebClientId,
    },
    cookies: {
      domain: globalConfig.cookies.domain,
      expires: '',
      path: globalConfig.cookies.path,
      secure: true,
    },
    template: {
      engine: globalConfig.template.engine,
      ext: globalConfig.template.ext,
    },
    adminPapi: {
      uri: globalConfig.adminPapi.uri,
    },
    bapi: {
      uri: globalConfig.bapi.uri,
    },
    creapi: {
      uri: globalConfig.creapi.uri,
    },
    hapi: {
      uri: globalConfig.hapi.uri,
    },
    inPapi: {
      uri: globalConfig.inPapi.uri,
    },
    lsPapi: {
      uri: globalConfig.lsPapi.uri,
    },
    papi: {
      uri: globalConfig.clapapi.uri,
    },
    projectProPapi: {
      uri: globalConfig.projectProPapi.uri,
    },
    ncinoService: {
      uri: globalConfig.ncinoService.uri,
    },
    paymentsPapi: {
      uri: globalConfig.paymentsPapi.uri,
    },
    search: {
      uri: globalConfig.search.uri,
    },
    toolingService: {
      uri: globalConfig.toolingService.uri,
    },
    rsPapi: {
      uri: globalConfig.rsPapi.uri,
    },
    ddPapi: {
      uri: globalConfig.ddPapi.uri,
    },
    devAdminPapi: {
      uri: globalConfig.devAdminPapi.uri,
    },
  };
};
